<div class="navbar">
    <a  [routerLink]="['/home']">Home</a>
    <a  [routerLink]="['/about']">About Us</a>
</div>